module.exports = __webpack_public_path__ + "static/apple-PLooh-d6bca35ec3599923e9c022aafff1dfb1.jpg";